// assets/main-collection.js

document.addEventListener('DOMContentLoaded', () => {
  const contentContainers = document.querySelectorAll('.rich-text.content-container');

  contentContainers.forEach((container) => {
    if (!container.innerHTML.trim()) {
      container.classList.add('hidden');
    }
  });
});

function initializeViewMoreButton() {
  const viewMoreButton = document.getElementById('view-more-button');
  const productGrid = document.getElementById('product-grid');

  if (viewMoreButton) {
    viewMoreButton.addEventListener('click', async () => {
      const nextUrl = viewMoreButton.getAttribute('data-next-url');

      if (nextUrl) {
        viewMoreButton.disabled = true;
        viewMoreButton.textContent = 'Loading...';

        try {
          const response = await fetch(nextUrl, {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
          });
          const data = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, 'text/html');
          const newItems = doc.querySelectorAll('#product-grid .grid__item:not(.grid__item--image)');
          const newViewMoreButton = doc.getElementById('view-more-button');

          // Only append regular product items, completely skip special images
          newItems.forEach((item) => {
            productGrid.appendChild(item);
          });

          if (newViewMoreButton) {
            viewMoreButton.setAttribute('data-next-url', newViewMoreButton.getAttribute('data-next-url'));
            viewMoreButton.disabled = false;
            viewMoreButton.textContent = 'View More';
          } else {
            viewMoreButton.remove();
          }
        } catch (error) {
          console.error('Error fetching next page:', error);
          viewMoreButton.disabled = false;
          viewMoreButton.textContent = 'View More';
        }
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', initializeViewMoreButton);